import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Fill from './Fill';
import { selectNormalizedInterval } from '../../../selectors';

function BufferedBar() {
  const [start,, duration] = useSelector(selectNormalizedInterval, shallowEqual);

  const buffered = useSelector(({ playback, controls }) => {
    if (controls.seekMode) {
      return {
        start: 0,
        end: 0,
      };
    }

    if (!playback.isLive) {
      return playback.buffered;
    }

    return {
      start: playback.buffered.start - start,
      end: playback.buffered.end - start,
    };
  }, shallowEqual);

  let bufferedStartPosition = Number(
    Math.min(buffered.start / duration, 1).toFixed(3),
  );
  let bufferedWidth = Number(
    ((buffered.end - buffered.start) / duration).toFixed(3),
  );

  // Prevent buffer indicator from displaying before the beginning of the timeline
  if (bufferedStartPosition < 0) {
    bufferedWidth -= Math.abs(bufferedStartPosition);
    bufferedStartPosition = 0;
  }

  // Prevent buffer indicator from going beyond the end of the timeline
  if (bufferedStartPosition + bufferedWidth > 1) {
    bufferedWidth = 1 - bufferedStartPosition;
  }

  return (
    <Fill
      color="bufferedBarFillColor"
      left={`${bufferedStartPosition * 100}%`}
      width={`${bufferedWidth * 100}%`}
    />
  );
}

export default React.memo(BufferedBar);
